import React, { useState, useEffect } from 'react';

const initialProducts = [
  { id: 1, name: 'Wireless Headphones', category: 'Electronics', price: 99.99, stock: 45, status: 'active', image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=50&h=50&fit=crop&crop=center' },
  { id: 2, name: 'Coffee Mug', category: 'Kitchen', price: 12.99, stock: 120, status: 'active', image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcf93a?w=50&h=50&fit=crop&crop=center' },
  { id: 3, name: 'Laptop Stand', category: 'Office', price: 49.99, stock: 0, status: 'inactive', image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=50&h=50&fit=crop&crop=center' },
  { id: 4, name: 'Phone Case', category: 'Accessories', price: 19.99, stock: 78, status: 'active', image: 'https://images.unsplash.com/photo-1601593346740-925612772716?w=50&h=50&fit=crop&crop=center' },
];

const initialOrders = [
  { id: 1001, customer: 'John Doe', product: 'Wireless Headphones', quantity: 2, total: 199.98, status: 'pending', date: '2024-01-15' },
  { id: 1002, customer: 'Jane Smith', product: 'Coffee Mug', quantity: 5, total: 64.95, status: 'shipped', date: '2024-01-14' },
  { id: 1003, customer: 'Bob Johnson', product: 'Phone Case', quantity: 1, total: 19.99, status: 'delivered', date: '2024-01-13' },
];

const initialCustomers = [
  { id: 1, name: 'John Doe', email: 'john@example.com', phone: '+1 (555) 123-4567', address: '123 Main St, New York, NY 10001', orders: 5, total: 299.95, status: 'active' },
  { id: 2, name: 'Jane Smith', email: 'jane@example.com', phone: '+1 (555) 987-6543', address: '456 Oak Ave, Los Angeles, CA 90210', orders: 12, total: 899.40, status: 'active' },
  { id: 3, name: 'Bob Johnson', email: 'bob@example.com', phone: '+1 (555) 456-7890', address: '789 Pine Rd, Chicago, IL 60601', orders: 3, total: 159.97, status: 'inactive' },
];

function App() {
  const [products, setProducts] = useState(() => {
    const saved = localStorage.getItem('products');
    return saved ? JSON.parse(saved) : initialProducts;
  });
  const [orders, setOrders] = useState(() => {
    const saved = localStorage.getItem('orders');
    return saved ? JSON.parse(saved) : initialOrders;
  });
  const [customers, setCustomers] = useState(() => {
    const saved = localStorage.getItem('customers');
    return saved ? JSON.parse(saved) : initialCustomers;
  });
  const [activeNav, setActiveNav] = useState('dashboard');
  const [showForm, setShowForm] = useState(false);
  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [formData, setFormData] = useState({ name: '', category: '', price: '', stock: '', status: 'active', image: '' });
  const [customerFormData, setCustomerFormData] = useState({ name: '', email: '', phone: '', address: '', status: 'active' });
  const [orderFormData, setOrderFormData] = useState({ customer: '', product: '', quantity: 1, status: 'pending' });
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [settings, setSettings] = useState({ theme: 'light', notifications: true, autoBackup: false });
  const [savedSettings, setSavedSettings] = useState({ theme: 'light', notifications: true, autoBackup: false });
  const [showSaveMessage, setShowSaveMessage] = useState(false);

  useEffect(() => {
    document.body.className = savedSettings.theme === 'dark' ? 'dark-theme' : '';
  }, [savedSettings.theme]);

  useEffect(() => {
    localStorage.setItem('products', JSON.stringify(products));
  }, [products]);

  useEffect(() => {
    localStorage.setItem('orders', JSON.stringify(orders));
  }, [orders]);

  useEffect(() => {
    localStorage.setItem('customers', JSON.stringify(customers));
  }, [customers]);

  const navItems = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'products', label: 'Products' },
    { id: 'orders', label: 'Orders' },
    { id: 'customers', label: 'Customers' },
    { id: 'analytics', label: 'Analytics' },
    { id: 'settings', label: 'Settings' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingProduct) {
      setProducts(products.map(p => p.id === editingProduct.id ? { ...formData, id: editingProduct.id } : p));
    } else {
      setProducts([...products, { ...formData, id: Date.now(), price: parseFloat(formData.price), stock: parseInt(formData.stock) }]);
    }
    resetForm();
  };

  const resetForm = () => {
    setFormData({ name: '', category: '', price: '', stock: '', status: 'active', image: '' });
    setEditingProduct(null);
    setShowForm(false);
  };

  const handleEdit = (product) => {
    setFormData(product);
    setEditingProduct(product);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      setProducts(products.filter(p => p.id !== id));
    }
  };

  const handleCustomerSubmit = (e) => {
    e.preventDefault();
    if (editingCustomer) {
      setCustomers(customers.map(c => c.id === editingCustomer.id ? { ...customerFormData, id: editingCustomer.id, orders: editingCustomer.orders, total: editingCustomer.total } : c));
    } else {
      setCustomers([...customers, { ...customerFormData, id: Date.now(), orders: 0, total: 0 }]);
    }
    resetCustomerForm();
  };

  const resetCustomerForm = () => {
    setCustomerFormData({ name: '', email: '', phone: '', address: '', status: 'active' });
    setEditingCustomer(null);
    setShowCustomerForm(false);
  };

  const handleEditCustomer = (customer) => {
    setCustomerFormData({ name: customer.name, email: customer.email, phone: customer.phone || '', address: customer.address || '', status: customer.status });
    setEditingCustomer(customer);
    setShowCustomerForm(true);
  };

  const handleDeleteCustomer = (id) => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      setCustomers(customers.filter(c => c.id !== id));
    }
  };

  const handleOrderSubmit = (e) => {
    e.preventDefault();
    const selectedProduct = products.find(p => p.id === parseInt(orderFormData.product));
    const selectedCustomer = customers.find(c => c.id === parseInt(orderFormData.customer));
    
    if (selectedProduct && selectedCustomer) {
      const newOrder = {
        id: Date.now(),
        customer: selectedCustomer.name,
        product: selectedProduct.name,
        quantity: parseInt(orderFormData.quantity),
        total: selectedProduct.price * parseInt(orderFormData.quantity),
        status: orderFormData.status,
        date: new Date().toISOString().split('T')[0]
      };
      
      setOrders([newOrder, ...orders]);
      setCustomers(customers.map(c => 
        c.id === selectedCustomer.id 
          ? { ...c, orders: c.orders + 1, total: c.total + newOrder.total }
          : c
      ));
      setProducts(products.map(p => 
        p.id === selectedProduct.id 
          ? { ...p, stock: p.stock - parseInt(orderFormData.quantity) }
          : p
      ));
    }
    
    setOrderFormData({ customer: '', product: '', quantity: 1, status: 'pending' });
    setShowOrderForm(false);
  };

  const handleExport = () => {
    const csv = 'Name,Category,Price,Stock,Status\n' + 
      products.map(p => `${p.name},${p.category},${p.price},${p.stock},${p.status}`).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'products.csv';
    a.click();
  };

  const filteredProducts = products.filter(p => {
    const matchesSearch = p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         p.category.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || p.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const renderContent = () => {
    switch(activeNav) {
      case 'dashboard':
        return (
          <div>
            <h1>Dashboard</h1>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginTop: '20px'}}>
              <div className="stat-card">
                <h3>Total Products</h3>
                <p>{products.length}</p>
              </div>
              <div className="stat-card">
                <h3>Total Orders</h3>
                <p>{orders.length}</p>
              </div>
              <div className="stat-card">
                <h3>Total Customers</h3>
                <p>{customers.length}</p>
              </div>
              <div className="stat-card">
                <h3>Revenue</h3>
                <p>${orders.reduce((sum, o) => sum + o.total, 0).toFixed(2)}</p>
              </div>
            </div>
            <div style={{marginTop: '30px'}}>
              <h2>Recent Orders</h2>
              <div className="product-table" style={{marginTop: '15px'}}>
                <table className="table">
                  <thead>
                    <tr><th>Order ID</th><th>Customer</th><th>Product</th><th>Total</th><th>Status</th></tr>
                  </thead>
                  <tbody>
                    {orders.slice(0, 3).map(order => (
                      <tr key={order.id}>
                        <td>#{order.id}</td>
                        <td>{order.customer}</td>
                        <td>{order.product}</td>
                        <td>${order.total}</td>
                        <td><span className={`status ${order.status === 'delivered' ? 'active' : 'inactive'}`}>{order.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      case 'orders':
        return (
          <div>
            <div className="header">
              <h1>Orders</h1>
              <div className="header-actions">
                <button className="btn btn-primary" onClick={() => setShowOrderForm(true)}>New Order</button>
              </div>
            </div>
            <div className="product-table">
              <table className="table">
                <thead>
                  <tr><th>Order ID</th><th>Customer</th><th>Product</th><th>Quantity</th><th>Total</th><th>Status</th><th>Date</th><th>Update Status</th></tr>
                </thead>
                <tbody>
                  {orders.map(order => (
                    <tr key={order.id}>
                      <td>#{order.id}</td>
                      <td>{order.customer}</td>
                      <td>{order.product}</td>
                      <td>{order.quantity}</td>
                      <td>${order.total}</td>
                      <td><span className={`status ${order.status === 'delivered' ? 'active' : 'inactive'}`}>{order.status}</span></td>
                      <td>{order.date}</td>
                      <td>
                        <select 
                          value={order.status} 
                          onChange={(e) => setOrders(orders.map(o => o.id === order.id ? { ...o, status: e.target.value } : o))}
                          className="status-select"
                        >
                          <option value="pending">Pending</option>
                          <option value="shipped">Shipped</option>
                          <option value="delivered">Delivered</option>
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'customers':
        return (
          <div>
            <div className="header">
              <h1>Customers</h1>
              <div className="header-actions">
                <input 
                  type="text" 
                  placeholder="Search customers..." 
                  value={customerSearchTerm}
                  onChange={(e) => setCustomerSearchTerm(e.target.value)}
                  className="search-input"
                />
                <select className="filter-select">
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                <button className="btn btn-primary" onClick={() => setShowCustomerForm(true)}>+ Add Customer</button>
              </div>
            </div>
            <div className="product-table">
              <table className="table">
                <thead>
                  <tr><th>Customer</th><th>Contact</th><th>Orders</th><th>Total Spent</th><th>Status</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {customers.filter(customer => 
                    customer.name.toLowerCase().includes(customerSearchTerm.toLowerCase()) ||
                    customer.email.toLowerCase().includes(customerSearchTerm.toLowerCase())
                  ).map(customer => (
                    <tr key={customer.id}>
                      <td>
                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                          <div style={{width: '45px', height: '45px', borderRadius: '50%', background: '#34495e', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '600', fontSize: '16px'}}>
                            {customer.name.charAt(0)}
                          </div>
                          <div>
                            <div style={{fontWeight: '600', fontSize: '15px'}}>{customer.name}</div>
                            <div style={{fontSize: '12px', color: '#64748b'}}>ID: #{customer.id}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div>
                          <div style={{fontWeight: '500'}}>{customer.email}</div>
                          <div style={{fontSize: '12px', color: '#64748b', marginTop: '2px'}}>{customer.phone || 'No phone provided'}</div>
                        </div>
                      </td>
                      <td>
                        <span style={{fontWeight: '600', color: '#3498db'}}>{customer.orders}</span>
                      </td>
                      <td>
                        <span style={{fontWeight: '600', fontSize: '15px'}}>${customer.total.toFixed(2)}</span>
                      </td>
                      <td><span className={`status ${customer.status}`}>{customer.status}</span></td>
                      <td>
                        <div className="actions">
                          <button className="action-btn" onClick={() => handleEditCustomer(customer)}>Edit</button>
                          <button className="action-btn" onClick={() => handleDeleteCustomer(customer.id)}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'analytics':
        return (
          <div>
            <h1>Analytics</h1>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginTop: '20px'}}>
              <div className="stat-card">
                <h3>Sales This Month</h3>
                <p>${orders.reduce((sum, o) => sum + o.total, 0).toFixed(2)}</p>
              </div>
              <div className="stat-card">
                <h3>Average Order Value</h3>
                <p>${(orders.reduce((sum, o) => sum + o.total, 0) / orders.length).toFixed(2)}</p>
              </div>
              <div className="stat-card">
                <h3>Top Category</h3>
                <p>Electronics</p>
              </div>
            </div>
            <div style={{marginTop: '30px'}}>
              <h2>Product Performance</h2>
              <div className="product-table" style={{marginTop: '15px'}}>
                <table className="table">
                  <thead>
                    <tr><th>Product</th><th>Sales</th><th>Revenue</th><th>Stock</th></tr>
                  </thead>
                  <tbody>
                    {products.map(product => (
                      <tr key={product.id}>
                        <td>{product.name}</td>
                        <td>{Math.floor(Math.random() * 50) + 1}</td>
                        <td>${(product.price * (Math.floor(Math.random() * 50) + 1)).toFixed(2)}</td>
                        <td>{product.stock}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      case 'settings':
        return (
          <div>
            <h1>Settings</h1>
            <div style={{maxWidth: '500px', marginTop: '20px'}}>
              <div className="settings-section">
                <h3>General Settings</h3>
                <div className="setting-item">
                  <label>Theme</label>
                  <select value={settings.theme} onChange={(e) => setSettings({...settings, theme: e.target.value})}>
                    <option value="light">Light</option>
                    <option value="dark">Dark</option>
                  </select>
                </div>
                <div className="setting-item">
                  <label>
                    <input type="checkbox" checked={settings.notifications} onChange={(e) => setSettings({...settings, notifications: e.target.checked})} />
                    Enable Notifications
                  </label>
                </div>
                <div className="setting-item">
                  <label>
                    <input type="checkbox" checked={settings.autoBackup} onChange={(e) => setSettings({...settings, autoBackup: e.target.checked})} />
                    Auto Backup
                  </label>
                </div>
                <button className="btn btn-primary" style={{marginTop: '20px'}} onClick={() => {
                  setSavedSettings(settings);
                  setShowSaveMessage(true);
                  setTimeout(() => setShowSaveMessage(false), 2000);
                  document.body.className = settings.theme === 'dark' ? 'dark-theme' : '';
                }}>Save Settings</button>
                {showSaveMessage && <p style={{color: '#22c55e', marginTop: '10px'}}>Settings saved successfully!</p>}
              </div>
            </div>
          </div>
        );
      case 'products':
      default:
        return (
          <div>
            <div className="header">
              <h1>Products List</h1>
              <div className="header-actions">
                <input 
                  type="text" 
                  placeholder="Search products..." 
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className="filter-select">
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                <button className="btn" onClick={handleExport}>Export</button>
                <button className="btn btn-primary" onClick={() => setShowForm(true)}>Add Product</button>
              </div>
            </div>
            <div className="product-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Category</th>
                    <th>Price</th>
                    <th>Stock</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.map(product => (
                    <tr key={product.id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <img 
                            src={product.image || 'https://via.placeholder.com/50x50/34495e/ffffff?text=' + product.name.charAt(0)} 
                            alt={product.name} 
                            className="product-image"
                            onError={(e) => {
                              e.target.src = 'https://via.placeholder.com/50x50/34495e/ffffff?text=' + product.name.charAt(0);
                            }}
                          />
                          {product.name}
                        </div>
                      </td>
                      <td>{product.category}</td>
                      <td>${product.price}</td>
                      <td>{product.stock}</td>
                      <td>
                        <span className={`status ${product.status}`}>
                          {product.status}
                        </span>
                      </td>
                      <td>
                        <div className="actions">
                          <button className="action-btn" onClick={() => handleEdit(product)}>Edit</button>
                          <button className="action-btn" onClick={() => handleDelete(product.id)}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="dashboard">
      <div className="sidebar">
        <div className="logo">Admin Panel</div>
        <nav>
          {navItems.map(item => (
            <button
              key={item.id}
              className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
              onClick={() => setActiveNav(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="main-content">
        {renderContent()}
        
        {showForm && (
          <div className="modal">
            <div className="modal-content">
              <h2>{editingProduct ? 'Edit Product' : 'Add Product'}</h2>
              <form onSubmit={handleSubmit}>
                <input type="text" placeholder="Product Name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
                <input type="text" placeholder="Category" value={formData.category} onChange={(e) => setFormData({...formData, category: e.target.value})} required />
                <input type="number" step="0.01" placeholder="Price" value={formData.price} onChange={(e) => setFormData({...formData, price: e.target.value})} required />
                <input type="number" placeholder="Stock" value={formData.stock} onChange={(e) => setFormData({...formData, stock: e.target.value})} required />
                <input type="url" placeholder="Image URL (e.g., https://example.com/image.jpg)" value={formData.image} onChange={(e) => setFormData({...formData, image: e.target.value})} />
                <select value={formData.status} onChange={(e) => setFormData({...formData, status: e.target.value})}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                <div className="form-actions">
                  <button type="button" className="btn" onClick={resetForm}>Cancel</button>
                  <button type="submit" className="btn btn-primary">{editingProduct ? 'Update' : 'Add'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {showCustomerForm && (
          <div className="modal">
            <div className="modal-content">
              <h2>{editingCustomer ? 'Edit Customer' : 'Add New Customer'}</h2>
              <form onSubmit={handleCustomerSubmit}>
                <div className="form-row">
                  <input type="text" placeholder="Full Name" value={customerFormData.name} onChange={(e) => setCustomerFormData({...customerFormData, name: e.target.value})} required />
                  <input type="email" placeholder="Email Address" value={customerFormData.email} onChange={(e) => setCustomerFormData({...customerFormData, email: e.target.value})} required />
                </div>
                <div className="form-row">
                  <input type="tel" placeholder="Phone Number" value={customerFormData.phone} onChange={(e) => setCustomerFormData({...customerFormData, phone: e.target.value})} />
                  <select value={customerFormData.status} onChange={(e) => setCustomerFormData({...customerFormData, status: e.target.value})}>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                <textarea placeholder="Address" value={customerFormData.address} onChange={(e) => setCustomerFormData({...customerFormData, address: e.target.value})} rows="3"></textarea>
                <div className="form-actions">
                  <button type="button" className="btn" onClick={resetCustomerForm}>Cancel</button>
                  <button type="submit" className="btn btn-primary">{editingCustomer ? 'Update Customer' : 'Add Customer'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {showOrderForm && (
          <div className="modal">
            <div className="modal-content">
              <h2>Create New Order</h2>
              <form onSubmit={handleOrderSubmit}>
                <div className="form-row">
                  <div>
                    <label>Customer</label>
                    <select value={orderFormData.customer} onChange={(e) => setOrderFormData({...orderFormData, customer: e.target.value})} required>
                      <option value="">Select Customer</option>
                      {customers.filter(c => c.status === 'active').map(customer => (
                        <option key={customer.id} value={customer.id}>{customer.name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label>Product</label>
                    <select value={orderFormData.product} onChange={(e) => setOrderFormData({...orderFormData, product: e.target.value})} required>
                      <option value="">Select Product</option>
                      {products.filter(p => p.status === 'active' && p.stock > 0).map(product => (
                        <option key={product.id} value={product.id}>{product.name} (${product.price})</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <input type="number" min="1" placeholder="Quantity" value={orderFormData.quantity} onChange={(e) => setOrderFormData({...orderFormData, quantity: e.target.value})} required />
                  <select value={orderFormData.status} onChange={(e) => setOrderFormData({...orderFormData, status: e.target.value})}>
                    <option value="pending">Pending</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                  </select>
                </div>
                {orderFormData.product && orderFormData.quantity && (
                  <div style={{padding: '12px', background: '#f8fafc', borderRadius: '6px', margin: '12px 0'}}>
                    <strong>Total: ${(products.find(p => p.id === parseInt(orderFormData.product))?.price * parseInt(orderFormData.quantity) || 0).toFixed(2)}</strong>
                  </div>
                )}
                <div className="form-actions">
                  <button type="button" className="btn" onClick={() => setShowOrderForm(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary">Create Order</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;